import { render, staticRenderFns } from "./ManageBoardPage.vue?vue&type=template&id=febdb924&"
import script from "./ManageBoardPage.vue?vue&type=script&lang=js&"
export * from "./ManageBoardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports